import { map, first } from 'rxjs/operators';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { StableBox } from '../_models/stableBox';

@Injectable()
export class StableBoxService {
  // Services
  private http = inject(HttpClient);
  private apiBaseUrl = environment.apiBaseUrl;
  stableBoxList: StableBox[];
  stableBoxList$: BehaviorSubject<Array<StableBox>> = new BehaviorSubject<Array<StableBox>>([]);
  stableBox$: BehaviorSubject<StableBox> = new BehaviorSubject<StableBox>(null);

  constructor() {}

  getStableBoxs(): Observable<StableBox[]> {
    return this.http.get<any>(this.apiBaseUrl + 'api/private/v1/stableboxes').pipe(
      map((response) => {
        this.stableBoxList = response;
        this.stableBoxList$.next(response);
        return response;
      })
    );
  }

  getStableBox(id: number): Observable<StableBox> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/stableboxes/' + id)
      .pipe(map((response) => response));
  }

  saveStableBox(stableBoxItem: StableBox): Observable<StableBox> {
    const stableBox = { ...stableBoxItem };

    delete stableBox.lastUpdated;
    delete stableBox.dateCreated;
    if (stableBox && stableBox.stable && stableBox.stable.id) {
      stableBox.stable = { id: stableBox.stable.id } as StableBox;
    }
    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    stableBox.companyId = companySelected ? companySelected.id : null;

    if (stableBox && stableBox.id) {
      return this.http
        .put(this.apiBaseUrl + 'api/private/v1/stableboxes/' + stableBox.id, stableBox)
        .pipe(map((response) => response));
    } else {
      return this.http
        .post(this.apiBaseUrl + 'api/private/v1/stableboxes/', stableBox)
        .pipe(map((response) => response));
    }
  }

  deleteStableBox(stableBox: StableBox): Observable<StableBox> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/stableboxes/' + stableBox.id).pipe(
      map((response) => {
        return { id: stableBox.id } as StableBox;
      })
    );
  }

  getStableBoxById = (id: number): StableBox => {
    let item: StableBox;
    this.stableBoxList$
      .pipe(first((list: StableBox[]) => list && list.length > 0))
      .subscribe((list: StableBox[]) => {
        item = list.find((i) => i.id === id);
      });
    return item;
  };

  /**
   * Get all stable boxes that belong to a specific stable
   * @param stableId - The ID of the stable
   * @returns Array of StableBox objects belonging to the stable
   */
  getStableBoxesByStableId = (stableId: number): StableBox[] => {
    let items: StableBox[] = [];
    this.stableBoxList$
      .pipe(first((list: StableBox[]) => list && list.length > 0))
      .subscribe((list: StableBox[]) => {
        items = list.filter((box) => box && box.stable && box.stable.id === stableId);
      });
    return items;
  };

  checkIfAnimalIdExistInStableBox(animalId) {
    const tmpBox = [];
    this.stableBoxList.forEach((box) => {
      if (box && box.animals && box.animals.length > 0) {
        box.animals.forEach((a) => {
          if (a && a.id && a.id === animalId) {
            tmpBox.push(box);
          }
        });
      }
    });
    return tmpBox;
  }

  getAnimalsWellnessLevel(
    typeOfWellness,
    beddingType,
    permanentSize,
    animalsSum,
    bunkNumber,
    wateringType,
    wateringPlaceNumber,
    linearMetersSize,
    stage
  ) {
    let ratio = 0;
    if (typeOfWellness == 'overcrowding') {
      if (beddingType == 'permanent' && permanentSize != 0 && animalsSum != 0) {
        ratio = parseFloat(permanentSize) / animalsSum;
      }
      if (beddingType == 'bunk' && bunkNumber != 0 && animalsSum != 0) {
        ratio = parseInt(bunkNumber) / animalsSum;
      }
    } else if (typeOfWellness == 'water_avaible') {
      if (wateringType == 'linear_meter' && linearMetersSize != 0 && animalsSum != 0) {
        ratio = linearMetersSize / animalsSum;
      }
      if (wateringType == 'watering_place' && wateringPlaceNumber != 0 && animalsSum != 0) {
        ratio = parseInt(wateringPlaceNumber) / animalsSum;
      }
    }
    if (ratio == 0) {
      return null;
    }
    let level = 0;
    const secondCondition =
      typeOfWellness == 'overcrowding'
        ? beddingType == 'permanent'
          ? stage == 'lactation' || stage == 'dry'
            ? //// permanente : fase lattazione e Asciutte
              6
            : stage == 'heifers'
              ? //// permanente : fase manze
                3.5
              : //// permanente : fase Vitelli 0-6
                1.6
          : //// cuccette
            0.9
        : wateringType == 'watering_place'
          ? //// beverini
            0.048
          : //// Metri
            0.06;

    const thirdCondition =
      typeOfWellness == 'overcrowding'
        ? beddingType == 'permanent'
          ? stage == 'lactation' || stage == 'dry'
            ? //// permanente : fase lattazione e Asciutte
              7
            : stage == 'heifers'
              ? //// permanente : fase manze
                4.5
              : //// permanente : fase Vitelli 0-6
                1.7
          : //// cuccette
            1
        : wateringType == 'watering_place'
          ? //// beverini
            0.06
          : //// Metri
            0.07;

    if (ratio < secondCondition) {
      level = 1;
    } else if (ratio >= secondCondition && ratio < thirdCondition) {
      level = 2;
    } else if (ratio >= thirdCondition) {
      level = 3;
    }

    return level;
  }
}
